import { Payload, UseCase } from '@smile-next/uikit';
import { ssoParamsRepository, SSOParamsRepository } from '@/infra/repository/SSOParamsRepository';
import { SSOParams } from '@/models/domain/SSOParams';

export class LoadedSSOParamsPayload extends Payload {
    type = 'LoadedSSOParamsPayload';
    constructor(public readonly ssoParams: SSOParams) {
        super();
    }
}

type LoadSSOParamsUsecaseArgs = {
    ssoParamsRepository?: SSOParamsRepository;
};

export class LoadSSOParamsUseCase extends UseCase {
    private infra: Required<LoadSSOParamsUsecaseArgs>;
    constructor(args: LoadSSOParamsUsecaseArgs = {}) {
        super();
        this.infra = {
            ssoParamsRepository,
            ...args,
        };
    }

    execute() {
        const ssoParams = this.infra.ssoParamsRepository.get();

        this.dispatch(new LoadedSSOParamsPayload(ssoParams));
    }
}
